import { StateSchema } from 'app/config/storeConfig/types';
import { UserRoles } from 'entities/User';

export const getSelectedRole = (state: StateSchema): Nullable<UserRoles> => state.createUserModal.selectedRole;
